import { render } from "./index.vue?vue&type=template&id=57aee1b2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PDFViewer/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57aee1b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57aee1b2', __exports__)) {
    api.reload('57aee1b2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=57aee1b2", () => {
    api.rerender('57aee1b2', render)
  })

}


export default __exports__